/**
 * The hand-off between "verify" and the portal. Deliberately just a loader —
 * see the git history for why there is no artwork here.
 *
 * This is the ONE transition the product plays (owner's direction, 26 Aug
 * 2026). Everything downstream of it renders immediately: the club chooser
 * only staggers its cards when it is reached from HERE, and never on a later
 * visit via "Switch club".
 */

import { RunnerCrewMark } from './ui';

export function RunSplash({ name }) {
  return (
    <div
      className="fixed inset-0 z-[90] flex flex-col items-center justify-center gap-5 bg-[linear-gradient(168deg,#161C2C_0%,#0D1220_52%,#0A0E19_100%)] motion-safe:animate-fadein"
      role="status"
      aria-live="polite"
    >
      <RunnerCrewMark size={40} />
      <div className="font-market text-[20px] font-extrabold tracking-[-0.025em] text-white">
        {name ? `Welcome back, ${name}` : 'Signing you in'}
      </div>
      <div
        className="relative h-[3px] w-[168px] overflow-hidden rounded-full bg-white/15"
        aria-hidden="true"
      >
        <span className="absolute bottom-0 top-0 w-[42%] rounded-full bg-gold-500 motion-safe:animate-sweep motion-reduce:w-full motion-reduce:opacity-70" />
      </div>
    </div>
  );
}
